import { Col, Row } from 'antd'
import { useNavigate } from 'react-router-dom'

const businessSections = [
    {
        title: 'Business Details',
        navigation: '/settings/businessInfo/details'
    },
    {
        title: 'Add Services',
        navigation: '/settings/businessInfo/services'
    },
    {
        title: 'Working Days',
        navigation: '/settings/businessInfo/schedule'
    },
    // {
    //     title: 'Complete',
    //     navigation: '/settings/businessInfo/temp'
    // },
]

const BusinessSections = () => {

    const navigate = useNavigate();

    return (
        <div>
            <h2 className='font-semibold text-lg'>Business information</h2>
            <Row className='bg-white my-2 py-5 px-3 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4' justify={'space-between'}>
                {
                    businessSections?.map((item, index) => {
                        return (
                            <>
                                <Col className='flex items-center gap-4 bg-gray-200 p-4 flex-wrap rounded-md cursor-pointer' key={index} onClick={() => navigate(item.navigation)}>
                                    {

                                        <div className='flex gap-1 items-center'>
                                            <div className='flex items-center justify-between border flex-wrap'>
                                                <span className='font-medium'>{item?.title}</span>
                                            </div>
                                        </div>
                                    }
                                </Col>
                            </>
                        )
                    })
                }
            </Row>
        </div>
    )
}

export default BusinessSections